module.exports = __webpack_public_path__ + "static/media/SquareLeftAdPreview.200be276.svg";